import { render } from "./TheLotteryForm.vue?vue&type=template&id=66e337a2&scoped=true"
import script from "./TheLotteryForm.vue?vue&type=script&lang=js"
export * from "./TheLotteryForm.vue?vue&type=script&lang=js"

import "./TheLotteryForm.vue?vue&type=style&index=0&id=66e337a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e337a2"]])

export default __exports__